import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";

import "./styles/tokens.css";
import { routeTree } from "./routeTree.gen";
import { createQueryClient } from "./lib/query";
import { SessionProvider } from "./lib/session";
import { ToastProvider } from "./ui/Toast";
import { applyTheme, readThemePreference, watchSystemTheme } from "./lib/theme";

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Keep the document in step with the system theme while the user has not made
// an explicit choice.
applyTheme(readThemePreference());
watchSystemTheme(() => {
  if (readThemePreference() === "system") applyTheme("system");
});

const container = document.getElementById("root");
if (!container) throw new Error("no #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
